var e="@hpstellar/core/attachable-product-tile-skeleton";export{e as attachableProductTileSkeletonTestId};
